'use client';

import { TriangleAlert } from 'lucide-react';
import { cn } from '@tinct/core-utils';

interface NoticeAlertProps {
  /** Notice text. Lines are separated by `\n`; the first line is emphasized. */
  notice: string;
  className?: string;
}

/**
 * Inline indigo alert used to surface a warning attached to a content block
 * (e.g. that saving will require regenerating all page variants).
 */
export function NoticeAlert({ notice, className }: NoticeAlertProps) {
  const lines = notice
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length === 0) return null;

  const [first, ...rest] = lines;

  return (
    <div
      className={cn(
        'flex gap-3 rounded-2xl border border-indigo-100 bg-indigo-50 p-4 text-indigo-600',
        className
      )}
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0" />
      <div className="flex flex-col gap-2 text-sm">
        <p className="font-medium">{first}</p>
        {rest.length > 0 && <p>{rest.join(' ')}</p>}
      </div>
    </div>
  );
}
